jQuery(document).ready(function ($) {
  var module_name = "player_statistics";

});
